(function(){

  var button = document.querySelector('.js-hamburger');
  var nav    = document.querySelector('.js-main-nav');

  button.addEventListener('click', function() {
    button.classList.toggle('is-active');
    $(nav).slideToggle(250);
  });

})();
